import ContentPage, { Eyebrow, PageTitle, Lead, H2, P, UL } from "@/components/ContentPage";
import { useSeo } from "@/lib/seo";

export default function Privacy() {
  useSeo({
    title: "Privacy & Data Information | Financial Future Readiness Assessment",
    description: "How the Financial Future Readiness Assessment handles the general planning information you provide, what it never asks for, and how contact requests are stored.",
    canonicalPath: "/privacy",
  });
  return (
    <ContentPage
      variant="plain"
      breadcrumbs={[
        { to: "/", label: "Home" },
        { to: "/privacy", label: "Privacy & Data" },
      ]}
    >
      <Eyebrow>Privacy</Eyebrow>
      <PageTitle>Privacy &amp; Data Information</PageTitle>
      <Lead>
        This page describes what the Financial Future Readiness Assessment asks for, what it does not ask for, how information is used,
        and the technical safeguards used to protect submitted information.
      </Lead>

      <H2>Information the assessment may ask for</H2>
      <UL>
        <li>Approximate age and retirement stage</li>
        <li>Estimated current monthly expenses</li>
        <li>General debt situation and types of liabilities</li>
        <li>Approximate ranges of savings and investable assets</li>
        <li>Account types held (e.g., checking, retirement, brokerage)</li>
        <li>Saving and investing habits</li>
        <li>Tax, insurance, protection, and estate planning preferences</li>
      </UL>

      <H2>Information we do not ask for</H2>
      <UL>
        <li>Social Security numbers</li>
        <li>Passwords or login credentials of any kind</li>
        <li>Exact account numbers or balances</li>
        <li>Tax identification numbers</li>
        <li>Financial-institution logins</li>
      </UL>
      <P>Please do not include this information anywhere in the assessment or contact form.</P>

      <H2>How assessment information is used</H2>
      <P>
        Your responses are used to calculate the educational readiness score you see on the results page.
        You are not required to provide any contact information in order to view the score.
      </P>

      <H2>Contact requests</H2>
      <P>
        You can complete the Financial Future Readiness Assessment and view your score without providing contact information.
        If you choose to request a plan review or schedule a Discovery Meeting after viewing your results, your contact information
        and assessment responses will be stored together so the planning team can respond to your request and review your assessment with you.
      </P>
      <P>
        Visitors who choose to schedule a Discovery Meeting may submit their contact information and then continue directly to the external
        scheduling page.
      </P>

      <H2>Security</H2>
      <P>
        Reasonable technical safeguards are used to protect submitted information, including secure transmission (HTTPS), protected backend systems,
        server-side validation, restricted administrative access, and environment-based credential management. No online system is absolutely secure,
        so please avoid submitting highly sensitive personal information here.
      </P>

      <H2>Educational nature</H2>
      <P>
        The score and result copy are educational only. They are not a financial plan, investment recommendation, tax opinion, legal opinion,
        insurance recommendation, or guarantee of future results. A complete review of your situation would require additional information about your
        individual circumstances.
      </P>
    </ContentPage>
  );
}
